import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLazyFetchUserDataQuery } from "../../store/services/auth/auth.service";
import { useAppDispatch, useAppSelector } from "../../store";
import { getFullState, logOut } from "../../store/slices/auth/auth.slice";
import Banner from "../Banner";
import SalesBanner from "../SalesBanner";
import { api } from "../../store/services";
import { getFullNotificationsState, configSnackbar } from "../../store/slices/notifications/notifications.slice";
import Snackbar from "@mui/material/Snackbar";
import { Helmet } from "react-helmet";
import { initGA, trackPageView } from "../../utils/analytics";
import useTidio from "../../hooks/useTidio";
import useTikTokPixel from "../../hooks/useTikTokPixel";
import useChatGptPixel from "../../hooks/useChatGptPixel";
import { initMetaPixel } from "../../utils/metaPixel";
import DeclarationModal from "../Modals/DeclarationModal";
const TrackPages = () => {
	const location = useLocation();

	useEffect(() => {
		trackPageView(location.pathname + location.search);
	}, [location]);

	return null;
};
const AppWrapper = () => {
	const localStorageToken = localStorage.getItem("token");
	const [searchParams] = useSearchParams();
	const query_token = searchParams.get("token");
	if (query_token) {
		localStorage.setItem("token", query_token);
	}
	const [callWhoami] = useLazyFetchUserDataQuery();
	const { snackBar } = useAppSelector(getFullNotificationsState);
	const [loader, setLoader] = useState(true);
	const { isLoggedIn, guideSteps } = useAppSelector(getFullState);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const isDev = process.env.NODE_ENV === "development";
	const isAdminRoute = location.pathname.includes("/admin");
	const [showServiceModal, setShowServiceModal] = useState(false);
	const serviceDeclaration = !!localStorage.getItem("hide_service_declaration");
	// use chat app
	useTidio();
	useTikTokPixel();
	useChatGptPixel();

	useEffect(() => {
		initGA();
	}, []);

	useEffect(() => {
		initMetaPixel();
	}, []);

	useEffect(() => {
		if (isLoggedIn) {
			switch (location.pathname) {
				case "/login": {
					const params = new URLSearchParams(location.search);
					const redirectUrl = params.get("redirect");
					return navigate(redirectUrl ? decodeURIComponent(redirectUrl) : "/");
				}
				case "/signup": {
					return navigate("/");
				}
				default: {
				}
			}
		}
	}, [isLoggedIn, location.pathname]);

	useEffect(() => {
		const check = setInterval(() => {
			if ((window as any).tidioChatApi) {
				// now Tidio is fully loaded, you can control it
				if (!isLoggedIn) {
					return (window as any).tidioChatApi.hide();
				}
				if (location.pathname === "/" || location.pathname.includes("/weddingInvitation")) {
					(window as any).tidioChatApi.hide();
				} else {
					(window as any).tidioChatApi.show();
				}
				clearInterval(check);
			}
		}, 300);

		return () => clearInterval(check);
	}, [isLoggedIn, location.pathname]);

	useEffect(() => {
		if (!isLoggedIn && (localStorageToken || query_token)) {
			callWhoami().then(() => {
				setLoader(false);
			});
		} else {
			setLoader(false);
		}
		//  logout user in case not token in local storage
		if (!localStorageToken) {
			dispatch(logOut());
			dispatch(api.util.resetApiState());
		}
	}, [isLoggedIn, localStorageToken]);
	const canShowHeader = !location.pathname.includes("/weddingInvitation/");

	return (
		<Box maxWidth={"1900px"} margin={"0 auto"}>
			<TrackPages />
			{(isDev || isAdminRoute) && (
				<Helmet>
					<meta name="robots" content="noindex, nofollow" />
				</Helmet>
			)}
			{loader ? (
				<Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100vh"}>
					<CircularProgress />
				</Box>
			) : (
				<Box>
					<Banner />
					<SalesBanner />
					<Box position={"relative"}>
						{canShowHeader && <Header />}
						<Box style={{ paddingTop: "var(--sales-banner-height, 0px)" }}>
							<Outlet />
						</Box>
					</Box>
				</Box>
			)}
			<ToastContainer position="top-right" hideProgressBar={true} theme="colored" />
			{
				<Snackbar
					anchorOrigin={{ vertical: snackBar.vertical || "bottom", horizontal: snackBar.horizontal || "right" }}
					open={snackBar.open}
					onClose={() => dispatch(configSnackbar({ open: false }))}
					message={snackBar.message}
					key={snackBar.vertical || "bottom" + snackBar.horizontal || "right"}
				/>
			}
			{showServiceModal && !serviceDeclaration && (
				<DeclarationModal
					open={true}
					onClose={() => {
						setShowServiceModal(false);
						localStorage.setItem("hide_service_declaration", "true");
					}}
					title={"Service Update"}
					description={<Box></Box>}
				/>
			)}
		</Box>
	);
};

export default AppWrapper;
